<script lang="ts">
	import { format } from 'svelte-i18n';
	import { is_enable_disable_scene_action_ui, is_play_scene_action_ui } from 'src/types/SceneActionUI';
	import { Text, SelectCard, CardGrid } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { DO_WIZARD_STEPS_INDEXES } from '../../helpers/do-wizard-helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let sceneData: any;

	const fullFillOptionsList = [
		{
			title: $format('action_enable_alarm', {
				default: 'Enable the alarm',
			}),
			desc: '',
			id: 'action_enable_scene',
			// Add this prop "translatedAlarmId" beacuse for setting sceneData.tranlsation is used helper actionInterpretator.
			// In this helper action for alarm is set with suffix "alarm".
			// Added mapping here to prevent introducing bug somewhere else
			translatedAlarmId: 'action_enable_alarm',
		},
		{
			title: $format('action_disable_alarm', {
				default: 'Disable the alarm',
			}),
			desc: '',
			id: 'action_disable_scene',
			translatedAlarmId: 'action_disable_alarm',
		},
		{
			title: $format('action_toggle_alarm', {
				default: 'Toggle the alarm',
			}),
			desc: '',
			id: 'action_toggle_scene',
			translatedAlarmId: 'action_toggle_alarm',
		},
	];

	if (
		is_play_scene_action_ui(sceneData.translated) ||
		is_enable_disable_scene_action_ui(sceneData.translated)
	) {
		sceneData.alarmAction.option = fullFillOptionsList.find(
			(el) => el.translatedAlarmId === sceneData.translated.option,
		)?.id;
	}

	const validateWizardStepChangeState = () => {
		sceneData.isValid = true;
		sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.ALARM_AS;
	};

	const onSelectExecutionOption = (id) => {
		validateWizardStepChangeState();
		sceneData.alarmAction.option = id;
	};
</script>

<Text element="h2" class="mb-s">
	{capFirstChar($format('alarm_execution_options', { default: 'Fullfil alarm as' }))}
</Text>

<CardGrid gridGap="s" lg={290} sm={270} noPaddingBottom>
	{#each fullFillOptionsList as option, i}
		<div class="d-flex">
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-full"
				type="horizontal"
				variant="radio"
				title={option.title}
				descriptiveText={option.desc}
				selected={sceneData.alarmAction.option === option.id}
				on:click={() => {
					onSelectExecutionOption(option.id);
				}}
			/>
		</div>
	{/each}
</CardGrid>
